import { render, staticRenderFns } from "./PopupField.vue?vue&type=template&id=267f3236&scoped=true&"
import script from "./PopupField.vue?vue&type=script&lang=js&"
export * from "./PopupField.vue?vue&type=script&lang=js&"
import style0 from "./PopupField.vue?vue&type=style&index=0&id=267f3236&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267f3236",
  null
  
)

export default component.exports